import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/myuser";
const PROFILE_FETCH_ERROR = "\u062e\u0637\u0627 \u062f\u0631 \u062f\u0631\u06cc\u0627\u0641\u062a \u067e\u0631\u0648\u0641\u0627\u06cc\u0644";
const PROFILE_UPDATE_ERROR = "\u062e\u0637\u0627 \u062f\u0631 \u0628\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06cc \u067e\u0631\u0648\u0641\u0627\u06cc\u0644";

export async function getProfile() {
  return requestWithAuth(`${API_BASE}/profile/`, {}, { fallbackMessage: PROFILE_FETCH_ERROR });
}

export async function updateProfile(payload) {
  return requestWithAuth(
    `${API_BASE}/profile/`,
    {
      method: "PATCH",
      body: JSON.stringify(payload),
    },
    { fallbackMessage: PROFILE_UPDATE_ERROR }
  );
}

export async function updateProfileFormData(formData) {
  return requestWithAuth(
    `${API_BASE}/profile/`,
    {
      method: "PATCH",
      body: formData,
    },
    { fallbackMessage: PROFILE_UPDATE_ERROR }
  );
}
